/**
 * internal dependencies
 */
import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { PIN_POOL_FORM } from '../form-cardgroup-types';
import { getParameters, generator } from '../../../../helpers/helpers';

import { displayPinPool } from './display-pin-pool';
import { newPinPoolWidget } from '../../../widgets/new-pin-pool-widget';
import { checkForUniquePin } from './pin-pool-helpers';

import GetCardGroupPinPool from '../../../../routes/get-pin-pool';

/**
 * function that gets individual card group information
 * 
 * @returns void
 */
export const cardGroupPinPool = async () => {
  const groupID = getParameters('cardGroupID');

  const [ cardgroup ] = await Promise.all([
    GetCardGroupPinPool(groupID)
  ]);

  displayPinPool(cardgroup);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');

  const gen = generator();
  const ppFieldContainer = PIN_POOL_FORM.ppFieldContainer;

  PIN_POOL_FORM.ppAddPinRecord.addEventListener('click', event => {
    event.preventDefault();
    const lastElement = document.querySelector('[data-pin-number]:last-child') as HTMLElement;
    const nextNum = lastElement ? String(parseInt(lastElement.dataset.pinNumber!) + 1) : String(gen.next().value);
    newPinPoolWidget(nextNum, ppFieldContainer);
    PIN_POOL_FORM.ppExport.removeAttribute('disabled')
  });

  let timeout: any;
  ppFieldContainer.addEventListener('keyup', event => {    
    const input = event.target as HTMLInputElement;      
    if (input.classList.contains('pin_number')) {
      input.dataset.pin = input.value.trim();
      clearTimeout(timeout);
      timeout = setTimeout(() => {          
        checkForUniquePin(input);
      }, 300);
    }
  });
}